const SPRITE_PATH = '/Static/images/sprites/symbols.svg';

declare global {
  interface Window {
    __SITE_VERSION__?: string;
  }
}

export function spriteUrl(symbolId: string): string {
  const version =
    typeof window !== 'undefined' ? window.__SITE_VERSION__ ?? '' : '';
  return version
    ? `${SPRITE_PATH}?v=${version}#${symbolId}`
    : `${SPRITE_PATH}#${symbolId}`;
}
